__turbopack_context__.v({
  "benefit": "mu6l-a_benefit",
  "cnoProInfoDescription": "mu6l-a_cnoProInfoDescription",
  "description": "mu6l-a_description",
});
